import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { PDFDocumentProxy, PdfViewerComponent } from 'ng2-pdf-viewer';
import { FormControl, FormGroup } from '@angular/forms';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';

@Component({
  selector: 'app-menuimpresiondocumentos',
  templateUrl: './menuimpresiondocumentos.component.html',
  styleUrls: ['./menuimpresiondocumentos.component.css']
})
export class MenuimpresiondocumentosComponent implements OnInit {

  showModal = false;

  onClose: Subject<string>;

  onPrintLocation: Subject<string> = new Subject<string>();
  onPrintPeticionPalet: Subject<string> = new Subject<string>();
  onPrintAlbaran: Subject<string> = new Subject<string>();
  onPrintCartela: Subject<string> = new Subject<string>();
  onPrintAll: Subject<string> = new Subject<string>();
  onPrintTestigo: Subject<string> = new Subject<string>();

  onPrintPrinter: Subject<string> = new Subject<string>();

  ArrayEntrada?: ArrayBuffer;
  loading = false;

  showHeader = false;

  pagina = 1;
  numberpages = 0;

  disabledTestigos = false;

  formulario = new FormGroup({
    chkprevisualizar: new FormControl(false)
  });

  constructor(
    private _bsModalRef: BsModalRef,
    private serviciosUtils: UtilitiesService
  ) { }

  isIE(): boolean {
    return this.serviciosUtils.isIE();
  }

  ngOnInit() {
  }

  printOnPrinter() {
    if (this.ArrayEntrada !== null && this.ArrayEntrada !== undefined) {
      this.onPrintPrinter.next();
    }
  }

  public onPrintAllAction() {
    this.onPrintAll.next();
    // this._bsModalRef.hide();
  }

  public onPrintLocationAction() {
    this.onPrintLocation.next();
    // this._bsModalRef.hide();
  }

  public onPrintAlbaranAction() {
    this.onPrintAlbaran.next();
    // this._bsModalRef.hide();
  }

  public onPrintCartelaAction() {
    this.onPrintCartela.next();
    // this._bsModalRef.hide();
  }

  public onPrintTestigoAction() {
    this.onPrintTestigo.next();
    // this._bsModalRef.hide();
  }

  public onPrintPeticionPaletAction() {
    this.onPrintPeticionPalet.next();
    // this._bsModalRef.hide();
  }

  showTextModal(quitarTestigo: boolean = false) {
    this.showModal = true;
    this.disabledTestigos = quitarTestigo;
  }

  public onConfirm(): void {
    this.showModal = false;
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.showModal = false;
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.showModal = false;
    this._bsModalRef.hide();
  }

  public showLoading(mostrar: boolean) {
    this.loading = mostrar;
    if (!mostrar && this.ArrayEntrada !== null && this.ArrayEntrada !== undefined) {
      this.showHeader = false;
      this.revisarOpciones();
    }
  }

  elijePrev(): boolean {
    return this.formulario.controls['chkprevisualizar'].value;
  }

  revisarOpciones() {
    if (!this.elijePrev()) {
      this.printOnPrinter();
    } else {
      this.showHeader = true;
    }
  }

  loadComplete(event: PDFDocumentProxy) {
    this.numberpages = event.numPages;
  }

  nextPage() {
    if (this.pagina < this.numberpages) {
      this.pagina++;
    }
  }

  previousPage() {
    if (this.pagina > 1) {
      this.pagina--;
    }
  }

}
